import PropTypes from 'prop-types';

const { LP } = window;

const SelectedFacet = ({ context, facet }) => {
  const handleMouseEnter = (e) => {
    if (['ccss', 'ss_ids'].includes(facet.key) && facet.isChild && !facet.isSelectAll) {
      LP.module('CommonCoreInfo').showPopover(e.currentTarget, facet.id);
    }
  };

  const handleClick = () => {
    context.executeAction(LP.module('Searches').SearchActions.toggleFacet, {
      facet
    });
  };

  const facetTitle = () => {
    const { title, isSelectAll: allSelected } = facet;

    switch (facet.key) {
      case 'language_ids':
        return title.concat(' ', 'Language');
      case 'subject_ids':
        if (facet.parent?.title === 'World Languages') {
          return allSelected ? title : 'Subject:'.concat(' ', title);
        }
        return title;
      case 'ss_ids':
        return allSelected ? title.concat(' ', 'Standards') : title;
      default:
        return title;
    }
  };

  return (
    <span
      className="bg-gray-200 cursor-pointer inline-block mx-1 mb-1 py-1 px-2 text-xs font-semibold rounded items-center whitespace-nowrap"
      onMouseEnter={handleMouseEnter}
      onClick={handleClick}
    >
      {facetTitle()}
      <i className="fa-solid fa-times ml-2 mt-px text-gray-500" />
    </span>
  );
};

SelectedFacet.propTypes = {
  context: PropTypes.object,
  facet: PropTypes.object
};

export default SelectedFacet;
